if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.targetButton = document.getElementById(this.dataset.targetButton);
        this.ownButton = this.querySelector('.sticky-atc__button');
        this.priceWrapper = this.querySelector(`#StickyAtcPrice-${this.sectionId}`);
      }

      connectedCallback() {
        // Hızlı ekle modalının içindeki kopya kendini body'ye taşımamalı;
        // sayfada iki tane sabit çubuk oluşurdu.
        if (this.closest('.quick-add-modal')) {
          this.remove();
          return;
        }

        // Bu bar `position: fixed`. Üst atalarından biri `transform`, `filter`,
        // `perspective`, `backdrop-filter`, `contain` veya `will-change` taşıyorsa
        // tarayıcı o atayı yeni bir "containing block" yapar ve bar viewport yerine
        // o kutuya sabitlenir — sayfanın belli bir yerinde takılı kalmasının sebebi bu.
        // (Örn. `.product__info-wrapper.scroll-trigger.animate--slide-in` transform kullanır.)
        // Elemanı body'nin sonuna taşıyarak sorunu kaynağında kesiyoruz.
        if (!this.swRelocated && this.parentElement !== document.body) {
          this.swRelocated = true;
          document.body.appendChild(this);
          return; // taşıma yeni bir connectedCallback tetikler
        }

        if (!this.targetButton) return;

        // Mirror a click on the sticky button through to the real, already-wired button
        // so every existing behaviour (quantity, gift-card recipient, cart drawer,
        // loading spinner, quantity rules) keeps working without duplication.
        this.ownButton?.addEventListener('click', () => {
          if (this.ownButton.hasAttribute('disabled')) return;
          this.targetButton.click();
        });

        this.setupVisibilityObserver();
        this.setupVariantChangeListener();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      setupVisibilityObserver() {
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            const isTargetVisible = entries[0]?.isIntersecting;
            this.classList.toggle('sticky-atc--visible', !isTargetVisible);
          },
          { threshold: 0 }
        );

        this.intersectionObserver.observe(this.targetButton);
      }

      setupVariantChangeListener() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          this.syncPrice();
          this.syncButtonState(event.data.variant);
        });
      }

      syncPrice() {
        const sourcePrice = document.getElementById(`price-${this.sectionId}`);
        if (sourcePrice && this.priceWrapper) {
          this.priceWrapper.innerHTML = sourcePrice.innerHTML;
        }
      }

      syncButtonState(variant) {
        if (!this.ownButton) return;

        const isDisabled = this.targetButton.hasAttribute('disabled');
        this.ownButton.toggleAttribute('disabled', isDisabled);

        const label = this.ownButton.querySelector('span');
        if (!label) return;

        if (!variant) {
          label.textContent = window.variantStrings?.unavailable || label.textContent;
        } else if (isDisabled) {
          label.textContent = window.variantStrings?.soldOut || label.textContent;
        } else {
          label.textContent = window.variantStrings?.addToCart || label.textContent;
        }
      }
    }
  );
}
